import { Button } from '@/components-new/button';
import { Dialog, DialogActions, DialogBody, DialogTitle } from '@/components-new/dialog';

type InvalidNdcSelectionModalProps = {
  open: boolean;
  onOk: () => void;
};

export const InvalidNdcSelectionDialog = ({ onOk, open }: InvalidNdcSelectionModalProps) => {
  return (
    <Dialog open={open} onClose={onOk}>
      <DialogTitle>Unable to Associate</DialogTitle>
      <DialogBody>
        One or more of the selections you chose are already associated to a product. Please double-check your selections and try again.
      </DialogBody>
      <DialogActions>
        <Button onClick={onOk}>OK</Button>
      </DialogActions>
    </Dialog>
  );
};
